import { useState, useEffect } from "react";
import bonsaiCache from "../services/bonsaiCache";

// Hook to get Bonsai dropdown data with caching
export const useBonsaiData = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Subscribe to cache updates
    const unsubscribe = bonsaiCache.subscribe((cachedData) => {
      setData(cachedData);
      setIsLoading(false);
      setError(null);
    });

    // If no cached data, start loading
    if (!bonsaiCache.isDataAvailable()) {
      setIsLoading(true);
      bonsaiCache.getData().catch((err) => {
        setError(err);
        setIsLoading(false);
      });
    }

    return unsubscribe;
  }, []);

  return {
    data,
    isLoading,
    error,
    isDataAvailable: bonsaiCache.isDataAvailable(),
  };
};

// Hook to preload Bonsai data (for use in route components)
export const useBonsaiPreload = () => {
  useEffect(() => {
    bonsaiCache.preload();
  }, []);
};

export default useBonsaiData;
